import { createApi, fetchBaseQuery  } from '@reduxjs/toolkit/query/react'

const cryptoNewsHeaders = {

        'x-bingapis-sdk': 'true',
        'x-rapidapi-host': 'bing-news-search1.p.rapidapi.com',
        'x-rapidapi-key': '4f5dfa972cmshcb6ce13b08bd807p15ab36jsnd23beb34c308'
 
}

const baseUrl = "https://bing-news-search1.p.rapidapi.com/"

const createRequest = url => ({url, headers: cryptoNewsHeaders})


export const cryptoNewsApi = createApi({
    reducerPath: 'cryptoNews',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({
        getCryptosNews: builder.query({
            query: ({newsCategory, count}) => createRequest(`/news/search?q=${newsCategory}&safeSearch=off&textFormat=Raw&freshness=Day&count=${count}`)
        })
    })
})

export const {useGetCryptosNewsQuery} = cryptoNewsApi